<template>
	<div class="login">
		<md-card>
			<md-ripple>
				<md-card-header>
					<div class="md-title">Login Here</div>
					<div class="md-subhead">@protopia</div>
				</md-card-header>

				<md-card-content>
					<md-field>
						<md-input v-model="email" placeholder="Email" @input="sanitizeEmail">
						</md-input>
					</md-field>
					<md-field>
						<md-input v-model="password" placeholder="Password" @input="sanitizePassword">
						</md-input>
					</md-field>

					<div class="card-reservation">
						<div class="md-button-group">
							<md-button>Login</md-button>
							<md-button>Register</md-button>
						</div>
					</div>
				</md-card-content>
			</md-ripple>
		</md-card>
	</div>
</template>
<script>
import API from "../services/API";
import { sanitizeInput } from '../utils/sanitizer';
export default {
  name: "Waterfall",
  props: ["community_code"],
  data() {
    return {
      api: new API(),
      communities: {},
      templates: [],
      email: "",
      password: ""
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData: async function() {
      await this.api.get(`templates`).then(templates => {
        this.templates = templates.data;
      });
      await this.api.get(`communities`).then(communities => {
        this.communities = communities.data;
      });
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    sanitizeEmail(value) {
      this.email = sanitizeInput(value);
    },
    sanitizePassword(value) {
      this.password = sanitizeInput(value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Register.vue